/**
 * Created by Kristy on 25/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportApprovals', {
                abstract: true,
                parent: 'app',
                url: '/report-approvals',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/medReportApprovals/medReportApprovals.html',
                        controller: 'MedReportApprovalsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

